<ws-modal-wrapper headerLabel="New Filing Batch"
                  (save)="save()"
                  (cancel)="cancel()"
                  [disableSave]="disableSave">
    <filing-batch-info
        [filingBatch]="filingBatch"
        [editMode]="true"
        (formValidityChanged)="formValid.set($event)"
        (filingBatchChange)="onFilingBatchChange($event)">
    </filing-batch-info>
</ws-modal-wrapper>


